import React from 'react';
import Attendance from './Attendance';
import '../../CommonCSS/SocietyCSS.css'

const AttendanceApp = () => {
  return (
    // <div className="App">
    //   <Common_Mst />
    // </div>
    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Daily Attendance</h5>
          </div>  
        </div>
        <Attendance/>
      </div>
    </div >
  );
};

export default AttendanceApp;
